import { Vue } from 'vue-property-decorator';

export interface Condition {}

export interface ConditionVolumePerSecond extends Condition {
	volumeValue?: number;
	volumeUnit?: string;
	waterMeterIds?: number[];
}

export interface ConditionRollingPeriod extends ConditionVolumePerSecond {
	periodValue?: number;
	periodUnit?: string;
}

export interface ConditionFixedPeriod extends ConditionRollingPeriod {
	startDay?: string;
}

export interface ConditionFixedDate extends ConditionVolumePerSecond {
	startDay?: number;
	startMonth?: number;
	endDay?: number;
	endMonth?: number;
}

export default abstract class WaterConsentConditionType<T extends Condition> extends Vue {
	public abstract getParameters(): T;
}
